export default __webpack_public_path__ + "static/media/logo.cd34f32e.png";